import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, RefreshCw } from "lucide-react";
import { Button } from "../ui/button";
import { euro } from "../../lib/api";

const STATUS = { paid: "Payée", processing: "En attente de la banque", failed: "Refusée", expired: "Abandonnée", refunded: "Remboursée", initiated: "Commencée" };
const EMAIL = { sent: "E-mail envoyé", failed: "E-mail non envoyé", sending: "Envoi en cours" };
const day = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");

export const OrdersTab = ({ call }) => {
  const [orders, setOrders] = useState([]);
  const [busy, setBusy] = useState(null);
  const load = () => call("get", "/admin/orders").then(setOrders).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const resend = async (sid) => {
    setBusy(sid);
    try { await call("post", `/admin/orders/${sid}/resend`); toast.success("Lien renvoyé au client"); load(); } catch { /* toast shown */ }
    setBusy(null);
  };
  return (
    <div data-testid="admin-orders">
      <div className="mb-3 flex items-center gap-3">
        <p className="text-sm opacity-70">Un lien expiré est renouvelé pour 7 jours au renvoi.</p>
        <Button size="sm" variant="outline" className="ml-auto rounded-full" onClick={load} data-testid="admin-orders-refresh"><RefreshCw className="h-4 w-4" /></Button>
      </div>
      <ul className="space-y-3" data-testid="admin-orders-list">
        {orders.length === 0 && <li className="text-sm opacity-70">Aucune commande pour l'instant.</li>}
        {orders.map((o) => (
          <li key={o.session_id} className="rounded-[20px] bg-white p-4 shadow-sm" data-testid={`admin-order-${o.session_id}`}>
            <div className="flex flex-wrap items-center gap-2">
              <p className="font-bold">{o.pack}</p>
              <span className="rounded-full bg-[#FFF9F2] px-3 py-0.5 text-xs font-semibold" data-testid={`admin-order-status-${o.session_id}`}>{STATUS[o.status] || o.status}</span>
              {o.email_status && <span className="text-xs opacity-70" data-testid={`admin-order-email-status-${o.session_id}`}>{EMAIL[o.email_status]}</span>}
              <span className="ml-auto text-xs opacity-60">{day(o.created_at)}</span>
            </div>
            <p className="mt-1 text-sm">{o.email || "Adresse inconnue"} · {euro(o.amount || 0)}</p>
            {o.status === "paid" && (
              <div className="mt-2 flex flex-wrap items-center gap-3 text-xs opacity-80">
                <span>Lien valable jusqu'au {day(o.expires_at)}</span>
                <span>{o.downloads} téléchargement(s)</span>
                <Button size="sm" className="ml-auto rounded-full bg-[#8A3FE0] hover:bg-[#7631c4]" disabled={busy === o.session_id || !o.email}
                  onClick={() => resend(o.session_id)} data-testid={`admin-order-resend-${o.session_id}`}>
                  <Send className="mr-1 h-4 w-4" /> Renvoyer le lien
                </Button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
